import React from 'react';
import { AudioPlayer } from '@cp/ds/src/components/audioPlayer';
import { skipToken } from '@reduxjs/toolkit/query';
import { EditableSection } from '@cp/ds/src/components/editableSection';
import { Typography } from '@cp/ds/src/components/typography';
import { coreClientApi } from 'src/entities/client/api/core';
import { useModal } from 'src/app/shared/hooks/useModal';
import { useSendMessageToClient } from 'src/features/dialog/sendMessageToClient/model/useSendMessageToClient';
import { CLIENT_AUDIO_EDIT_MODAL_NAME } from 'src/app/shared/components/modals/clientAudioEdit/const';
import { ClientAudioSectionProps } from './model';

export const ClientAudioSection: React.FC<ClientAudioSectionProps> = ({ clientId, sx }) => {
  const { data: audioFiles } = coreClientApi.useGetClientAudioQuery(clientId ? { clientId } : skipToken);
  const { openModal } = useModal();
  const sendMessageToClient = useSendMessageToClient();

  const handleEdit = () => {
    if (clientId && audioFiles && audioFiles.length > 0) {
      const audioFile = audioFiles[0];
      openModal(CLIENT_AUDIO_EDIT_MODAL_NAME, {
        audioFile,
        clientId,
        onSubmit: async (values, context) => {
          if (values.message && clientId) {
            await sendMessageToClient(
              {
                clientId,
                message: values.message,
                sendCopyBySms: values.sendCopyBySms,
              },
              { form: context.form },
            );
          }
          context.onClose();
        },
      });
    }
  };

  if (!audioFiles || audioFiles.length === 0) {
    return null;
  }

  const audioFile = audioFiles[0];

  return (
    <EditableSection
      onEdit={handleEdit}
      sx={sx}
      title={
        <>
          Аудио-обращение<Typography variant="body">(не обязательно)</Typography>
        </>
      }
    >
      <AudioPlayer size="normal" source={audioFile.audioUrl} sx={{ flex: 1 }} />
    </EditableSection>
  );
};
